// @ts-nocheck
import { getPendingInvites } from 'src/redux/slices/user/endpoints'

import { Typography } from '@material-ui/core'

import PendingInvite from './PendingInvite'

///// Component
const PendingInviteList: React.FC = () => {
  const { data: invites } = getPendingInvites.useQuery('')
  if (!invites) return <Typography>Loading...</Typography>
  return (
    <>
      {invites?.length > 0 && <Typography variant='h5'>Pending Invitations</Typography>}
      {invites?.map(({ organization_id: org, id }, i) => {
        if (org) return <PendingInvite key={`pending-invite-${i}`} org={org} id={id} />
        return <></>
      })}
    </>
  )
}

export default PendingInviteList
